module.exports = __webpack_public_path__ + "assets/images/profiles/1970s.png?v=d58f0525";